import React from 'react';
import { motion } from 'framer-motion';
import { Globe2, Award, Building2, Users, Shield, Compass, Target, CheckCircle2, Quote, ArrowRight, Linkedin, Mail, MapPin, Briefcase } from 'lucide-react';
import { Button } from '../components/ui/Button';
const teamMembers = [{
  img: 'https://cdn.magicpatterns.com/uploads/93iHqBWDYW59vBd6ETs28a/ChatGPT_Image_May_15,_2026,_02_38_21_PM.png',
  name: 'Juliette Langford',
  role: 'Talent Source Specialist',
  sectors: 'Technology · Financial Services',
  bio: 'Leads global sourcing strategy with deep expertise across SaaS, fintech, and capital markets. Previously in-house at two unicorn tech firms.'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/dCmLcdnYsZBJk7moBDm373/WhatsApp_Image_2026-05-15_at_9.43.49_PM.jpg',
  name: 'Olivia Grace Thompson',
  role: 'TalentForge Consulting',
  sectors: 'Healthcare · Life Sciences',
  bio: 'Two decades advising healthcare boards on CEO and executive leadership transitions. Specialist in clinical and biotech mandates.'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/bV8f9jrq8qNVJVCieVkLCx/WhatsApp_Image_2026-05-16_at_11.25.26_AM.jpg',
  name: 'Rebecca Collins',
  role: 'Talent Intelligence Consultant',
  sectors: 'Market Mapping · Talent Analytics',
  bio: 'Architect of our proprietary talent intelligence framework. Provides data-driven market mapping for sensitive executive mandates.'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/xfH4KoMwYQtv7qvDr5LwrF/WALTER_EDWARD.png',
  name: 'Shawn Tate',
  role: 'Executive Resume Writer & Documentation Specialist',
  sectors: 'Executive Branding · Career Positioning',
  bio: 'Career storyteller for senior executives. Has positioned over 1,200 C-suite leaders for their next chapter.'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/s51NVFBhbaHFVJBxpJSHf7/WhatsApp_Image_2026-05-17_at_4.04.29_PM.jpg',
  name: 'Jennifer Charles',
  role: 'Talent Strategic Consultant',
  sectors: 'Manufacturing · Industrial',
  bio: 'Advises industrial and manufacturing clients on long-cycle leadership planning, including PE-backed leadership transitions.'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/cYUQdm3kEyenGjBTk1CkdX/WhatsApp_Image_2026-05-18_at_1.35.50_PM.jpg',
  name: 'Charlotte Evelyn',
  role: 'Talent Strategies Consulting',
  sectors: 'Aerospace · Defense · Government',
  bio: 'Specializes in cleared and regulated industry placements. Brings 18 years of aerospace and defense leadership search experience.'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/vCLwfUU963CwQXXBFwaBk8/1748627143622.jpg',
  name: 'Eric Hecksel, SHRM-CP',
  role: 'Human Resources',
  sectors: 'People Operations · Talent Management',
  bio: 'SHRM-CP certified HR leader who shapes people strategy across the talent lifecycle, from organizational design to leadership development and workforce planning.'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/dAAhPzxn1dyKEDcbor73ub/fyvh.png',
  name: 'Seraphina Lyra',
  role: 'Executive Resume Expert',
  sectors: 'Executive Branding · Career Positioning',
  bio: 'Crafts compelling executive narratives that elevate senior leaders. Translates complex career histories into precise, board-ready resumes and leadership profiles.'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/gzfVzLDJqSDhFY99HtpZGF/1517057775363.jpg',
  name: 'Glenn (Hautaaho) Aho, MPA, SPHR',
  role: 'Job Search Placement Expert',
  sectors: 'Placement Strategy · Talent Acquisition',
  bio: 'SPHR-certified placement strategist with an MPA background, guiding leaders through high-stakes job searches and connecting them with the right executive opportunities.'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/miG8DMGydYtXChuEmmjTcs/dara.jpg_(1).jpg',
  name: 'Dara Mariles',
  role: 'Executive Search | Talent Acquisition | Strategic Hiring Partner',
  sectors: 'Executive Search · Strategic Hiring',
  bio: 'A strategic hiring partner who leads executive search and talent acquisition mandates end to end, aligning leadership hiring with long-term business strategy.'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/i6BEArQEj4Q1tL1KytHhfD/ChatGPT_Image_Jun_30,_2026,_06_23_23_AM.png',
  name: 'Jimmy Murkison',
  role: 'Senior Recruiter',
  sectors: 'Talent Sourcing · Candidate Engagement',
  bio: 'A seasoned senior recruiter who builds trusted relationships with candidates and clients alike, sourcing and securing top talent across competitive markets.'
}];
const regions = [{
  name: 'North America',
  detail: 'New York · Chicago · Toronto',
  count: '12'
}, {
  name: 'Europe',
  detail: 'London · Frankfurt · Zurich',
  count: '9'
}, {
  name: 'Asia Pacific',
  detail: 'Singapore · Hong Kong · Tokyo',
  count: '8'
}, {
  name: 'Middle East',
  detail: 'Dubai · Riyadh',
  count: '5'
}, {
  name: 'Latin America',
  detail: 'São Paulo · Mexico City',
  count: '4'
}, {
  name: 'Africa',
  detail: 'Johannesburg · Lagos',
  count: '4'
}];
const credentials = ['AESC member firm (Association of Executive Search and Leadership Consultants)', 'ISO 27001 certified for information security', 'Recognized in Hunt Scanlon Top Recruiting Firms (2024 & 2025)', 'Member, World Economic Forum Talent Community', 'Diamond accreditation from the Recruitment & Employment Confederation'];
const values = [{
  icon: Shield,
  title: 'Discretion',
  desc: 'Every search is conducted with the absolute confidentiality required by sensitive leadership mandates.'
}, {
  icon: Compass,
  title: 'Judgment',
  desc: 'Our consultants bring operating experience and pattern recognition that goes beyond résumé matching.'
}, {
  icon: Target,
  title: 'Precision',
  desc: 'We present shortlists, not longlists. Every candidate has been deeply assessed against your specific need.'
}, {
  icon: Users,
  title: 'Partnership',
  desc: 'We measure success in two-year retention and impact — not in time-to-fill metrics.'
}];
export function AboutPage() {
  return <div className="bg-white" data-id="element-148">
      {/* ─── HERO MASTHEAD ────────────────────────────────────── */}
      <section className="relative bg-navy-900 text-white pt-32 pb-24 overflow-hidden" data-id="element-149">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-gold-500/5 rounded-full blur-3xl translate-x-1/3 -translate-y-1/3" data-id="element-150" />

        <div className="relative max-w-7xl mx-auto px-6 lg:px-12" data-id="element-151">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end" data-id="element-152">
            <div className="lg:col-span-8" data-id="element-153">
              <div className="flex items-center gap-3 mb-8" data-id="element-154">
                <div className="w-12 h-px bg-gold-500" data-id="element-155" />
                <span className="text-gold-500 font-semibold tracking-[0.3em] uppercase text-xs" data-id="element-156">
                  Our Firm
                </span>
              </div>
              <motion.h1 initial={{
              opacity: 0,
              y: 30
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.8
            }} className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold leading-[1.05] mb-8 tracking-tight" data-id="element-157">
                Trusted by boards.
                <br data-id="element-158" />
                <span className="italic text-gold-500" data-id="element-159">
                  Built for the consequential hire.
                </span>
              </motion.h1>
            </div>
            <div className="lg:col-span-4" data-id="element-160">
              <p className="text-xl text-gray-300 leading-relaxed font-light" data-id="element-161">
                TalentBridge Global is an executive search and leadership
                advisory firm partnering with the world's most ambitious
                organizations to identify and secure transformative leadership
                talent.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ─── FOUNDER LETTER ───────────────────────────────────── */}
      <section className="py-28 bg-white" data-id="element-162">
        <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-163">
          <div className="flex items-center gap-3 mb-12" data-id="element-164">
            <div className="w-12 h-px bg-gold-500" data-id="element-165" />
            <span className="text-gold-600 font-semibold tracking-[0.25em] uppercase text-xs" data-id="element-166">
              A Note From Our Founder
            </span>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start" data-id="element-167">
            {/* Founder portrait + meta */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:col-span-5" data-id="element-168">
              <div className="relative" data-id="element-169">
                <div className="aspect-[4/5] overflow-hidden rounded-sm shadow-2xl" data-id="element-170">
                  <img src="https://cdn.magicpatterns.com/uploads/tTqNpJV6JT8vHgbfGQsLGE/ChatGPT_Image_May_17,_2026,_12_32_41_AM.png" alt="Wills Martins" className="w-full h-full object-cover" data-id="element-171" />
                </div>
                {/* Gold accent badge */}
                <div className="absolute -bottom-6 -right-6 bg-gold-500 text-navy-900 p-6 max-w-[200px] shadow-xl" data-id="element-172">
                  <div className="text-xs uppercase tracking-widest font-bold mb-1" data-id="element-173">
                    Founder & CEO
                  </div>
                  <div className="text-lg font-serif font-bold leading-tight" data-id="element-174">
                    Wills Martins
                  </div>
                </div>
              </div>

              <div className="mt-12 space-y-4 pl-2 border-l-2 border-gold-500/30 pl-6" data-id="element-175">
                <div data-id="element-176">
                  <div className="text-xs uppercase tracking-widest text-gray-400 mb-1" data-id="element-177">
                    Tenure
                  </div>
                  <div className="text-navy-900 font-semibold" data-id="element-178">
                    25+ years in executive search
                  </div>
                </div>
                <div data-id="element-179">
                  <div className="text-xs uppercase tracking-widest text-gray-400 mb-1" data-id="element-180">
                    Background
                  </div>
                  <div className="text-navy-900 font-semibold" data-id="element-181">
                    Former CHRO · Fortune 500 industrial
                  </div>
                </div>
                <div data-id="element-182">
                  <div className="text-xs uppercase tracking-widest text-gray-400 mb-1" data-id="element-183">
                    Sectors
                  </div>
                  <div className="text-navy-900 font-semibold" data-id="element-184">
                    Cross-sector C-suite & board mandates
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Letter body */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="lg:col-span-7" data-id="element-185">
              <Quote className="h-10 w-10 text-gold-500 mb-6" data-id="element-186" />

              <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy-900 leading-tight mb-8" data-id="element-187">
                "Every leadership search is a moment that shapes the next decade
                of an organization. We treat it that way."
              </h2>

              <div className="space-y-5 text-gray-700 leading-relaxed text-[17px]" data-id="element-188">
                <p data-id="element-189">
                  I founded TalentBridge Global after 25 years inside boardrooms
                  — first as a Chief Human Resources Officer, then as a
                  confidant to CEOs navigating leadership transitions. What I
                  saw was a recruitment industry optimized for speed and volume,
                  not for the consequential decisions that actually move
                  organizations forward.
                </p>
                <p data-id="element-190">
                  Our firm was built on a different premise: that the best
                  executive search is closer to advisory than to staffing. It
                  requires judgment, sector fluency, and the discretion to
                  handle the most sensitive moments in an organization's life.
                  It also requires the courage to tell clients the truth — about
                  the market, about the role, and sometimes about themselves.
                </p>
                <p data-id="element-191">
                  Today, we serve boards, CEOs, and senior leadership teams
                  across 42 countries. We are deliberately senior-heavy: every
                  mandate is led by a consultant with operating experience in
                  your sector. We do not delegate to junior researchers, and we
                  do not measure ourselves on time-to-fill. We measure ourselves
                  on the long-term success of the leaders we place.
                </p>
                <p className="font-serif italic text-navy-900 text-lg pt-4" data-id="element-192">
                  Thank you for considering TalentBridge for what may be your
                  most important hire of the year.
                </p>
              </div>

              {/* Signature */}
              <div className="mt-12 pt-8 border-t border-gray-200 flex items-center justify-between" data-id="element-193">
                <div data-id="element-194">
                  <div className="font-serif font-bold text-navy-900 text-xl mb-1" data-id="element-195">
                    Wills Martins
                  </div>
                  <div className="text-sm text-gray-500" data-id="element-196">
                    Founder & Chief Executive Officer
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-197">
                  <a href="#" aria-label="LinkedIn" className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center text-gray-600 hover:bg-navy-900 hover:text-white hover:border-navy-900 transition-colors" data-id="element-198">
                    <Linkedin className="h-4 w-4" data-id="element-199" />
                  </a>
                  <a href="mailto:glenn@talentbridge.blog" aria-label="Email" className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center text-gray-600 hover:bg-navy-900 hover:text-white hover:border-navy-900 transition-colors" data-id="element-200">
                    <Mail className="h-4 w-4" data-id="element-201" />
                  </a>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ─── MISSION & POSITIONING ────────────────────────────── */}
      <section className="py-28 bg-gray-50" data-id="element-202">
        <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-203">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-20" data-id="element-204">
            <div className="lg:col-span-5" data-id="element-205">
              <div className="flex items-center gap-3 mb-6" data-id="element-206">
                <div className="w-12 h-px bg-gold-500" data-id="element-207" />
                <span className="text-gold-600 font-semibold tracking-[0.25em] uppercase text-xs" data-id="element-208">
                  Our Mission
                </span>
              </div>
              <h2 className="text-4xl md:text-5xl font-serif font-bold text-navy-900 leading-tight" data-id="element-209">
                Identify the leaders who will define the next decade.
              </h2>
            </div>
            <div className="lg:col-span-6 lg:col-start-7" data-id="element-210">
              <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-211">
                We exist to help boards and CEOs make their most important
                leadership decisions with confidence. That means surfacing not
                just qualified candidates, but the right candidate — one whose
                judgment, capability, and values align with the organization's
                strategic ambition.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-212">
                Our work spans CEO succession, C-suite recruitment, board
                composition, and leadership advisory — always grounded in deep
                sector knowledge and the kind of long-view counsel that
                separates a transaction from a true partnership.
              </p>
            </div>
          </div>

          {/* Values pillars */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-gray-200" data-id="element-213">
            {values.map((value, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white p-8 group hover:bg-navy-900 transition-colors duration-500" data-id="element-214">
                <value.icon className="h-7 w-7 text-gold-500 mb-6" data-id="element-215" />
                <h3 className="text-xl font-serif font-bold text-navy-900 group-hover:text-white transition-colors mb-3" data-id="element-216">
                  {value.title}
                </h3>
                <p className="text-sm text-gray-600 group-hover:text-gray-300 transition-colors leading-relaxed" data-id="element-217">
                  {value.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* ─── GLOBAL POSITIONING ───────────────────────────────── */}
      <section className="py-28 bg-white" data-id="element-218">
        <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-219">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-220">
            <div className="lg:col-span-6" data-id="element-221">
              <div className="flex items-center gap-3 mb-6" data-id="element-222">
                <div className="w-12 h-px bg-gold-500" data-id="element-223" />
                <span className="text-gold-600 font-semibold tracking-[0.25em] uppercase text-xs" data-id="element-224">
                  Global Footprint
                </span>
              </div>
              <h2 className="text-4xl md:text-5xl font-serif font-bold text-navy-900 leading-tight mb-6" data-id="element-225">
                A genuinely global firm — with local depth where it matters.
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-226">
                Our consultants operate from six regions and partner across more
                than forty markets. We bring the cross-border perspective
                international searches require, paired with the local
                relationships that make them succeed.
              </p>
            </div>

            <div className="lg:col-span-5 lg:col-start-8 flex items-end" data-id="element-227">
              <div className="bg-navy-900 text-white p-10 w-full" data-id="element-228">
                <div className="text-gold-500 font-semibold tracking-[0.2em] uppercase text-xs mb-6" data-id="element-229">
                  Reach
                </div>
                <div className="grid grid-cols-2 gap-8" data-id="element-230">
                  <div data-id="element-231">
                    <div className="text-5xl font-serif font-bold mb-2" data-id="element-232">42</div>
                    <div className="text-sm text-gray-400 leading-tight" data-id="element-233">
                      Markets served
                    </div>
                  </div>
                  <div data-id="element-234">
                    <div className="text-5xl font-serif font-bold mb-2" data-id="element-235">6</div>
                    <div className="text-sm text-gray-400 leading-tight" data-id="element-236">
                      Regional offices
                    </div>
                  </div>
                  <div data-id="element-237">
                    <div className="text-5xl font-serif font-bold mb-2" data-id="element-238">
                      85+
                    </div>
                    <div className="text-sm text-gray-400 leading-tight" data-id="element-239">
                      Senior consultants
                    </div>
                  </div>
                  <div data-id="element-240">
                    <div className="text-5xl font-serif font-bold mb-2" data-id="element-241">9</div>
                    <div className="text-sm text-gray-400 leading-tight" data-id="element-242">
                      Languages spoken
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Region grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-gray-200" data-id="element-243">
            {regions.map((region, index) => <motion.div key={index} initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="bg-white p-8 group hover:bg-gray-50 transition-colors relative overflow-hidden" data-id="element-244">
                <div className="absolute top-0 left-0 h-1 w-0 group-hover:w-full bg-gold-500 transition-all duration-500" data-id="element-245" />
                <div className="flex items-start justify-between mb-4" data-id="element-246">
                  <MapPin className="h-5 w-5 text-gold-500" data-id="element-247" />
                  <span className="text-3xl font-serif text-gray-200 group-hover:text-gold-500 transition-colors" data-id="element-248">
                    {region.count}
                  </span>
                </div>
                <h3 className="text-xl font-serif font-bold text-navy-900 mb-2" data-id="element-249">
                  {region.name}
                </h3>
                <p className="text-sm text-gray-500" data-id="element-250">{region.detail}</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* ─── LEADERSHIP TEAM ──────────────────────────────────── */}
      <section id="team" className="py-28 bg-gray-50 scroll-mt-24" data-id="element-251">
        <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-252">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-253">
            <div className="lg:col-span-5" data-id="element-254">
              <div className="flex items-center gap-3 mb-6" data-id="element-255">
                <div className="w-12 h-px bg-gold-500" data-id="element-256" />
                <span className="text-gold-600 font-semibold tracking-[0.25em] uppercase text-xs" data-id="element-257">
                  Leadership Team
                </span>
              </div>
              <h2 className="text-4xl md:text-5xl font-serif font-bold text-navy-900 leading-tight" data-id="element-258">
                The consultants behind your search.
              </h2>
            </div>
            <div className="lg:col-span-6 lg:col-start-7 flex items-end" data-id="element-259">
              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-260">
                Our partners average over 18 years of executive search and
                operating experience. Every engagement is led personally by a
                senior consultant — not delegated to a research associate.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-gray-200" data-id="element-261">
            {teamMembers.map((member, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="bg-white group" data-id="element-262">
                <div className="aspect-[4/5] overflow-hidden relative" data-id="element-263">
                  <img src={member.img} alt={member.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-264" />
                  <div className="absolute inset-0 bg-gradient-to-t from-navy-900/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-265" />
                  <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-266">
                    <a href="#" aria-label="Email" className="w-9 h-9 rounded-full bg-white/95 flex items-center justify-center text-navy-900 hover:bg-gold-500 hover:text-white transition-colors" data-id="element-267">
                      <Mail className="h-4 w-4" data-id="element-268" />
                    </a>
                  </div>
                </div>
                <div className="p-7" data-id="element-269">
                  <h3 className="text-xl font-serif font-bold text-navy-900 mb-1 leading-tight" data-id="element-270">
                    {member.name}
                  </h3>
                  <p className="text-gold-600 font-semibold text-sm mb-3" data-id="element-271">
                    {member.role}
                  </p>
                  <div className="text-xs uppercase tracking-widest text-gray-400 mb-3" data-id="element-272">
                    {member.sectors}
                  </div>
                  <p className="text-sm text-gray-600 leading-relaxed" data-id="element-273">
                    {member.bio}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* ─── EXECUTIVE SEARCH CREDIBILITY ─────────────────────── */}
      <section className="py-28 bg-navy-900 text-white relative overflow-hidden" data-id="element-274">
        <div className="absolute top-0 right-0 w-96 h-96 bg-gold-500/10 rounded-full blur-3xl translate-x-1/3 -translate-y-1/3" data-id="element-275" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-gold-500/5 rounded-full blur-3xl -translate-x-1/3 translate-y-1/3" data-id="element-276" />

        <div className="relative max-w-7xl mx-auto px-6 lg:px-12" data-id="element-277">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-278">
            <div className="lg:col-span-5" data-id="element-279">
              <div className="flex items-center gap-3 mb-6" data-id="element-280">
                <div className="w-12 h-px bg-gold-500" data-id="element-281" />
                <span className="text-gold-500 font-semibold tracking-[0.25em] uppercase text-xs" data-id="element-282">
                  Credentials & Standing
                </span>
              </div>
              <h2 className="text-4xl md:text-5xl font-serif font-bold leading-tight mb-6" data-id="element-283">
                The credentials behind the work.
              </h2>
              <p className="text-lg text-gray-300 leading-relaxed" data-id="element-284">
                Membership and recognition that reflect the standards we hold
                ourselves to.
              </p>
            </div>

            <div className="lg:col-span-7 lg:col-start-6" data-id="element-285">
              <div className="space-y-1" data-id="element-286">
                {credentials.map((item, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: 20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.1
              }} className="flex items-start gap-4 py-5 border-b border-white/10 last:border-b-0" data-id="element-287">
                    <CheckCircle2 className="h-5 w-5 text-gold-500 mt-1 flex-shrink-0" data-id="element-288" />
                    <span className="text-gray-200 leading-relaxed" data-id="element-289">
                      {item}
                    </span>
                  </motion.div>)}
              </div>
            </div>
          </div>

          {/* Award strip */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 pt-16 mt-16 border-t border-white/10" data-id="element-290">
            {[{
            value: '$12B+',
            label: 'Compensation negotiated for placed executives'
          }, {
            value: '500+',
            label: 'Executive placements completed'
          }, {
            value: '94%',
            label: 'Two-year retention rate'
          }, {
            value: '42',
            label: 'Countries served'
          }].map((stat, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="text-center md:text-left" data-id="element-291">
                <div className="text-4xl md:text-5xl font-serif font-bold text-gold-500 mb-3" data-id="element-292">
                  {stat.value}
                </div>
                <div className="text-sm text-gray-400 leading-snug" data-id="element-293">
                  {stat.label}
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* ─── BEGIN A CONVERSATION CTA ─────────────────────────── */}
      <section className="py-28 bg-white" data-id="element-294">
        <div className="max-w-5xl mx-auto px-6 lg:px-12 text-center" data-id="element-295">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-296">
            <div className="w-12 h-px bg-gold-500" data-id="element-297" />
            <span className="text-gold-600 font-semibold tracking-[0.25em] uppercase text-xs" data-id="element-298">
              Begin a Conversation
            </span>
            <div className="w-12 h-px bg-gold-500" data-id="element-299" />
          </div>

          <h2 className="text-4xl md:text-5xl font-serif font-bold text-navy-900 leading-tight mb-6" data-id="element-300">
            Considering your next critical hire?
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto mb-10" data-id="element-301">
            Our senior consultants are available for a confidential,
            no-obligation scoping conversation. We will respond within one
            business day.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-302">
            <Button variant="gold" size="lg" href="mailto:contact@talentbridge.blog" data-id="element-303">
              Request a Consultation
              <ArrowRight className="ml-2 h-4 w-4" data-id="element-304" />
            </Button>
            <Button variant="outline" size="lg" href="/services" data-id="element-305">
              Explore Our Practice
            </Button>
          </div>
        </div>
      </section>
    </div>;
}